import { batch } from 'react-redux';
import orderBy from 'lodash/orderBy';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request/index';
import { getCitiesByRegion } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-by-region';
import { IRegionCity } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-by-region/dto/ResponseDto';
import { IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

import { setSelectedRegion } from '../actionCreators';

import updateRegion from './updateRegions';

const fetchRegionCities = (region: IRegionWithCities) => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState): Promise<void> => {
        const state = getState();
        const { selectedRegion } = state.citySelect;
        const providerId = selectProviderId(state);

        if (region.region_id === selectedRegion?.region_id) {
            dispatch(setSelectedRegion(null));
            return;
        }

        if (!region.cities?.length) {
            const resp = await doRequest.apiContent<IRegionCity[]>(
                getCitiesByRegion(providerId, { id: region.region_id }),
            );

            if (resp.isSuccess) {
                const cities = orderBy(resp.payload, ['main', 'name'], ['desc', 'asc']);

                batch(() => {
                    dispatch(setSelectedRegion({ ...region, cities }));
                    dispatch(updateRegion(region, cities));
                });
            }
            return;
        }

        dispatch(setSelectedRegion(region));
    };
};

export default fetchRegionCities;
